import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "hidden sm:inline-block sm:align-middle sm:h-screen",
  "aria-hidden": "true"
}, "​", -1)
const _hoisted_3 = { class: "inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-md sm:w-full sm:p-6" }
const _hoisted_4 = { class: "mt-2 text-center sm:mt-5" }
const _hoisted_5 = { class: "mt-3 flex flex-col gap-y-4" }
const _hoisted_6 = { class: "text-left uppercase" }
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = { class: "text-left uppercase" }
const _hoisted_9 = { class: "text-left uppercase" }
const _hoisted_10 = ["placeholder"]
const _hoisted_11 = { class: "text-left uppercase" }
const _hoisted_12 = ["placeholder"]
const _hoisted_13 = { class: "text-left uppercase" }
const _hoisted_14 = ["placeholder"]
const _hoisted_15 = { class: "text-left uppercase" }
const _hoisted_16 = ["placeholder"]
const _hoisted_17 = { class: "text-left uppercase" }
const _hoisted_18 = ["placeholder"]
const _hoisted_19 = { class: "text-left" }
const _hoisted_20 = { class: "mt-5 sm:mt-6 text-center" }
const _hoisted_21 = ["disabled"]

import { translate } from "@/utils/tools";
import { computed, inject, onMounted, ref, watch } from "vue";
import {
  Dialog,
  DialogTitle,
  DialogOverlay,
  TransitionRoot,
  TransitionChild,
  Switch,
} from "@headlessui/vue";
import DropdownComponent from "../tools/DropdownComponent.vue";
import { AxiosInstance } from "axios";
import { useStore } from "vuex";

export default /*#__PURE__*/_defineComponent({
  __name: 'SubEventCreateDialog',
  props: { form: Object, show: Boolean, event_id: Object },
  emits: ["submit", "update:show", "update:form", "created"],
  setup(__props, { emit }) {

const props = __props

const CheckIcon = require("@heroicons/vue/solid/CheckIcon");
const store = useStore();
const axios = inject("$axios") as AxiosInstance;

const selectedProvider = ref({ label: "-Select Provider-", value: null });
const dataProvider = ref([]);
const query = ref("");

const showSync = computed({
  get: () => props.show,
  set: (value) => emit("update:show", value),
});
const form = ref({
  // operatorId: store.state.selectedOperator.operatorId,
  name: "",
  providers: "",
  description: "",
  target_settle_amount: "",
  target_settle_count: "",
  target_valid_amount: "",
  target_round_count: "",
  is_active: true,
});
const isLoading = ref(false);

const fetchPageData = async () => {
  const payload = {
    operatorId: store.state.selectedOperator.operatorId,
  };
  const url = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/game/internal/provider`;
  return await axios.post(url, payload).then(({ data }) =>
    data.result.map((row: any) => ({
      label: row.providerCode,
      value: row.providerCode,
    }))
  );
};

const onCreate = async () => {

  if (isLoading.value) return;
  isLoading.value = true;
  try {
    const playload = {
      name: form.value.name,
      description: form.value.description,
      providers: selectedProvider.value.value,
      config: [
        {
          target_settle_amount: form.value.target_settle_amount,
          target_settle_count: form.value.target_settle_count,
          target_valid_amount: form.value.target_valid_amount,
          target_round_count: form.value.target_round_count,
        },
      ],
      is_active: form.value.is_active,
      event_id: props.event_id,
    };
    await axios.post(
      `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/event/api/sub-events/create`,
      playload,
      {
        headers: {
          "x-cm-operator-id": store.state.selectedOperator.operatorId,
        },
      }
    );

  } catch (error) {
    console.log(error);
  } finally {
    isLoading.value = false;
  }

  emit("created");
  showSync.value = false;
  clearForm();
};

const onProviderSelected = (e: any) => {
  selectedProvider.value = e;
  // form.providers = e.value;
  emit("update:form", { ...props.form, providers: e.value });
};

const clearForm = () => {
  form.value = {
    name: "",
    providers: "",
    description: "",
    target_settle_amount: "",
    target_settle_count: "",
    target_valid_amount: "",
    target_round_count: "",
    is_active: true,
  };
  selectedProvider.value = { label: "-Select Provider-", value: null };
};

const onClose = () => {
  clearForm();
  showSync.value = false;
};
// watch("query", async (val) => {
//   dataProvider.value = await fetchPageData();
// });
watch(showSync, async (val) => {
  if (val) {
    dataProvider.value = await fetchPageData();
  }
});




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(TransitionRoot), {
      as: "template",
      show: _unref(showSync),
      static: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Dialog), {
          as: "div",
          static: "",
          class: "fixed z-10 inset-0 overflow-y-auto",
          onClose: _cache[9] || (_cache[9] = ($event: any) => (showSync.value = false)),
          open: _unref(showSync)
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0",
                "enter-to": "opacity-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100",
                "leave-to": "opacity-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogOverlay), { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" })
                ]),
                _: 1
              }),
              _hoisted_2,
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_unref(DialogTitle), {
                          as: "h3",
                          class: "text-lg leading-6 font-medium text-gray-900"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("messages.event.createSubEvent")), 1)
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("messages.event.subName")), 1),
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.name) = $event)),
                              class: "rounded w-full",
                              placeholder: _ctx.$t('messages.event.subName')
                            }, null, 8, _hoisted_7), [
                              [_vModelText, form.value.name]
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("messages.event.providerName")), 1),
                            _createVNode(DropdownComponent, {
                              class: "w-full",
                              options: dataProvider.value,
                              modelValue: selectedProvider.value,
                              onOnOptionSelected: onProviderSelected
                            }, null, 8, ["options", "modelValue"])
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t("messages.event.description")), 1),
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.description) = $event)),
                              class: "rounded w-full",
                              placeholder: _ctx.$t('messages.event.description')
                            }, null, 8, _hoisted_10), [
                              [_vModelText, form.value.description]
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t("messages.event.targetSettleAmount")), 1),
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              class: "rounded w-full",
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.target_settle_amount) = $event)),
                              min: "0",
                              placeholder: _ctx.$t('messages.event.targetSettleAmount')
                            }, null, 8, _hoisted_12), [
                              [_vModelText, form.value.target_settle_amount]
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t("messages.event.targetSettleCount")), 1),
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              class: "rounded w-full",
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.target_settle_count) = $event)),
                              min: "0",
                              placeholder: _ctx.$t('messages.event.targetSettleCount')
                            }, null, 8, _hoisted_14), [
                              [_vModelText, form.value.target_settle_count]
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$t("messages.event.targetValidAmount")), 1),
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              class: "w-full rounded",
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.target_valid_amount) = $event)),
                              min: "0",
                              placeholder: _ctx.$t('messages.event.targetValidAmount')
                            }, null, 8, _hoisted_16), [
                              [_vModelText, form.value.target_valid_amount]
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.$t("messages.event.targetRoundCount")), 1),
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              class: "w-full rounded",
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.target_round_count) = $event)),
                              min: "0",
                              placeholder: _ctx.$t('messages.event.targetRoundCount')
                            }, null, 8, _hoisted_18), [
                              [_vModelText, form.value.target_round_count]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_19, [
                            _createTextVNode(_toDisplayString(_ctx.$t("messages.reward.active")) + " ", 1),
                            _createVNode(_unref(Switch), {
                              modelValue: form.value.is_active,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.is_active) = $event)),
                              class: _normalizeClass(["relative inline-flex h-6 w-11 items-center rounded-full", form.value.is_active? 'bg-blue-400' : 'bg-red-500'])
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", {
                                  class: _normalizeClass([form.value.is_active ? 'translate-x-6' : 'translate-x-1', "inline-block h-4 w-4 transform rounded-full bg-white"])
                                }, null, 2)
                              ]),
                              _: 1
                            }, 8, ["modelValue", "class"])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (onClose())),
                        class: "mt-3 mr-2 inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                      }, _toDisplayString(_ctx.$t("messages.event.close")), 1),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (onCreate())),
                        disabled: isLoading.value,
                        class: "mt-3 ml-2 inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-blue-400 text-base font-medium text-white hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                      }, _toDisplayString(_ctx.$t("messages.event.submit")), 9, _hoisted_21)
                    ])
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["open"])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})